export default (translatorString, replacements) => {
  let string = translatorString;

  if (replacements !== undefined && string) {
    Object.entries(replacements).forEach(([key, value]) => {
      const reg = new RegExp(`\\$\\{${key}\\}`, 'g');
      string = string.replace(reg, value);
    });
  }

  return string;
};
